// extracted by mini-css-extract-plugin
export default {"container":"Header_container__3cNJG","left":"Header_left__8B5zd","right":"Header_right__mriBi","title":"Header_title__mW9Xx"};